import React from 'react';

import {
    FieldSelect,
    FieldSelectProps,
} from 'reactApp/components/Forms/FieldSelect';

import styles from './NetworkSelect.css';

type Option = {
    key?: string;
    value: string;
    text: string;
    description?: string;
    content?: React.ReactNode;
};

const NEW_NETWORK_VALUE = 'new';

const DEFAULT_OPTIONS: Option[] = [
    {
        value: NEW_NETWORK_VALUE,
        text: 'Создать новую сеть',
    },
];

const DEFAULT_OPTIONS_WITH_LINK: Option[] = [
    {
        value: NEW_NETWORK_VALUE,
        key: NEW_NETWORK_VALUE,
        text: 'Создать новую сеть',
        content: (
            <a
                href="/app/services/server/network/add/"
                className={styles.createNetworkLink}
            >
                Создать новую сеть
            </a>
        ),
    },
];

const _getNetworkOptions = (
    networks: any[],
    newNetworkValue?: boolean,
    newNetworkLink?: boolean,
): Option[] => {
    const options = networks.map(
        ({ id, name, customFields, private_dns_domain }) => {
            return {
                value: id,
                text: customFields ? customFields.fullName : name,
                description: private_dns_domain,
            };
        },
    );

    if (newNetworkValue) {
        return [...DEFAULT_OPTIONS, ...options];
    }
    if (newNetworkLink) {
        return [...DEFAULT_OPTIONS_WITH_LINK, ...options];
    }
    return options;
};

type NetworkSelectProps = {
    networks: any[];
    newNetworkValue?: boolean;
    newNetworkLink?: boolean;
} & FieldSelectProps;
export const NetworkSelect = ({
    networks,
    newNetworkValue,
    newNetworkLink,
    ...otherSelectProps
}: NetworkSelectProps) => {
    const options = _getNetworkOptions(
        networks,
        newNetworkValue,
        newNetworkLink,
    );
    return (
        <FieldSelect
            {...{
                options,
                selectedValueCustomRender,
                ...otherSelectProps,
            }}
        />
    );

    function selectedValueCustomRender(selectedValue) {
        const selectedOption = options.find(
            (option) => option.value === selectedValue,
        );
        if (!selectedOption) {
            return '';
        }

        return (
            <div data-test="select-network" className={styles.trigger}>
                <div className={styles.text}>{selectedOption.text}</div>
                {selectedOption.description && (
                    <div className={styles.description}>
                        {selectedOption.description}
                    </div>
                )}
            </div>
        );
    }
};

NetworkSelect.NEW_NETWORK_VALUE = NEW_NETWORK_VALUE;
